module.exports = __webpack_public_path__ + "static/media/BasicBadge.586e7e52.svg";